export default __webpack_public_path__ + "static/media/LU.58d7c920.svg";